<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="classmate-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.classmateName" placeholder="请输入班组名称" @keydown.enter="resetSearch">
            <template #prefix>班组名称</template>
          </el-input>
          <employee-select v-model="searchInfo.leader">
            <template #prefix>负责人</template>
          </employee-select>
          <el-select v-model="searchInfo.projectId" placeholder="请选择项目" clearable>
            <template #prefix>项目名称</template>
            <el-option v-for="item in projectList" :key="item.id" :value="item.id" :label="item.projectName"/>
          </el-select>
          <el-select v-model="searchInfo.siteId" placeholder="请选择工地" clearable>
            <template #prefix>工地名称</template>
            <el-option v-for="item in siteList" :key="item.id" :value="item.id" :label="item.siteName"/>
          </el-select>
          <el-select v-model="searchInfo.lot" placeholder="请选择标段" clearable>
            <template #prefix>标段</template>
            <el-option v-for="item in lotList" :key="item.id" :value="item.dictCode" :label="item.dictName"/>
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="project:classmate:save" el-type="success"
                       @click="$router.push(`/project/classmate/detail`)">新建
          </page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="classmateList">
          <yq-table-column label="项目名称" prop="projectName" min-width="120rem"/>
          <yq-table-column label="工地名称" prop="siteName" min-width="120rem"/>
          <yq-table-column label="班组名称" prop="classmateName" min-width="120rem"/>
          <yq-table-column label="负责人" prop="leaderName"/>
          <yq-table-column label="标段" prop="lotName"/>
          <yq-table-column label="施工工地" prop="siteName"/>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem"
                           :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button hasPerm="project:classmate:save"
                              @click="$router.push(`/project/classmate/detail?id=${row.id}`)">编辑
                </table-button>
                <table-button hasPerm="project:classmate:assign" @click="access2Site(row)">指派</table-button>
                <table-button hasPerm="project:classmate:remove" el-type="danger" message="是否确认删除数据"
                              @click="deleteRow(row.id)">删除
                </table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
      <el-dialog v-model="showDetail" title="请选择要指派的工地" dialog-width="1">
        <form-items label-width="2.4rem" icon-width="0" :columns="1">
          <form-item label="工地名称">
            <el-select v-model="currentData.siteId">
              <el-option v-for="item in siteList" :key="item.id" :value="item.id" :label="item.siteName"/>
            </el-select>
          </form-item>
        </form-items>
        <div slot="footer">
          <page-button el-type="primary" @click="save">确认</page-button>
        </div>
      </el-dialog>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import classmateApi from "@/api/dz-luqiao/luqiaoClassmateApi"
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import util from "@/util/util";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "CL",
  components: {
    EmployeeSelect,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, FormItem, FormItems
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      currentData: null,
      siteList: [],
      showDetail: false,
      projectList: [],
      lotList: [],
      userInfo: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    this.userInfo = await util.getUserInfo();
    // 标段
    commonApi.queryDictionaryList("LOT", this.userInfo.merchantId).then(list => {
      this.lotList = list;
    })
    commonLqApi.querySiteNoPage().then(list => this.siteList = list);
    commonLqApi.queryProjectNoPage().then(list => this.projectList = list);
    this.resetSearch();
  },
  methods: {
    async queryList() {
      const {records, totalCount} = await classmateApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async access2Site(row) {

      this.currentData = row;
      this.showDetail = true;
    },
    async save() {
      await classmateApi.assignSite(this.currentData.siteId, this.currentData.id)
      this.showDetail = false;
      this.$message.success("保存成功")
      await this.queryList()
    },
    async deleteRow(id) {
      await classmateApi.delete(id);
      this.resetSearch()
    }
  }
};
</script>

<style lang="scss" scoped>
.classmate-list {
  height: 100%;
}
</style>